import React from 'react';
import styled from 'styled-components';
import { Headline } from '@oneaudi/unified-web-components';
import { SEM_COLOR_FEEDBACK_SURFACE_ERROR_LIGHT } from '@oneaudi/unified-web-common';
import { isEditMode } from '../../context/Context';
import { useInitialState } from '../../context/InitialStateContext';
import { getCarlineIdsWithoutDiscoverLinks } from '../../utils/getCarlineIdsWithoutDiscoverLinks';

const ErrorMessage = styled.span`
  color: ${SEM_COLOR_FEEDBACK_SURFACE_ERROR_LIGHT};
  display: block;
`;

const EditModeWarning = () => {
  const editMode = isEditMode();
  const { carlineGroups } = useInitialState();
  const carlineIdsWithoutDiscoverLinks = getCarlineIdsWithoutDiscoverLinks(carlineGroups);

  if (!editMode || carlineIdsWithoutDiscoverLinks.length === 0) {
    return null;
  }

  return (
    <div style={{ paddingBlockEnd: '3rem', paddingInline: '2rem' }}>
      <Headline tag="h1" variant={{ type: 'headline', order: '4', weight: 'normal' }}>
        <ErrorMessage>
          There are carlines without discover link attached. The feature app will still render, but
          this is an error on the data side that needs to be fixed. Affected carline ids: [
          {carlineIdsWithoutDiscoverLinks.join(', ')}]
        </ErrorMessage>
      </Headline>
    </div>
  );
};

export default EditModeWarning;
